/* eslint-disable no-console */
import { useCallback } from "react";
import { ConfirmationStatus } from "../constants";
import { State, DialogData } from "./interfaces";

export const useDialogManager = (
    state: State,
    setState,
) => {
    const show = useCallback(
        (dialogData: DialogData) => {
            if(!dialogData) {
                console.error("Dialog data is not provided.");
                return;
            }
            const doShow = () => {
                setState({
                    dialogData: dialogData,
                    status: ConfirmationStatus.READY,
                });
            };
            
            if (state.modalOpen) {
                setState((prevState) => ({
                    ...prevState,
                    status: ConfirmationStatus.CLOSED,
                }));
                setTimeout(doShow, 500);
            } else {
                doShow();
            }
        },
        [state.modalOpen, setState],
    );

    return show;
};
